import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

import FormModal from "./FormModal";

function Header() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  // console.log(pathname);

  useEffect(() => {
    // console.log("is scroll");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    const handler = (event) => {
      if (event.data === "iframeFormSubmitted") {
        setShow(false);  // close modal
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);


  const openIframeWindow = () => {
    setShow(!show);

    // const win = window.open("", "_blank", "width=800,height=600");
    // win.document.write(`
    //   <iframe
    //                   src="https://vr.biohackforlifesuccess.com/widget/form/tic4BJkP6Bm4hJUJsDKn"
    //                   style={{"width":"100%","height":"100%","border":"none","borderRadius":"3px"}}
    //                   id="inline-tic4BJkP6Bm4hJUJsDKn"
    //                   data-layout="{'id':'INLINE'}"
    //                   data-trigger-type="alwaysShow"
    //                   data-trigger-value=""
    //                   data-activation-type="alwaysActivated"
    //                   data-activation-value=""
    //                   data-deactivation-type="neverDeactivate"
    //                   data-deactivation-value=""
    //                   data-form-name="EPLIMO FUNNEL - Calendar Sign Up"
    //                   data-height="1860"
    //                   data-layout-iframe-id="inline-tic4BJkP6Bm4hJUJsDKn"
    //                   data-form-id="tic4BJkP6Bm4hJUJsDKn"
    //                   title="EPLIMO FUNNEL - Calendar Sign Up"
    //                 >
    //                 </iframe>
    // `);
  };


  return (
    <>
      <nav className="navbar navbar-expand-lg nav_fix bg1">
        <div className="container">
          <div className="nav_bg_box">
            <div className="d-lg-flex  align-items-end w100">
              <div className="d-flex m-auto   ">
                <Link to="/" className="navbar-brand  d-inline-block">
                  <img className="logo_dark" src="/assets/img/logo.svg" alt="Logo" />
                  <img className="logo_light" src="/assets/img/logo-light.svg" alt="Logo" />
                </Link>
                <button
                  className="navbar-toggler ms-auto"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsibleNavbar"
                >
                  <i className="bi bi-list" />
                </button>
              </div>
              <div
                className="collapse navbar-collapse  "
                id="collapsibleNavbar"
              >
                <ul className="navbar-nav  ms-auto     align-items-center">
                  <li className="nav-item">
                    <Link to="/casestudies" className="nav-link">
                      {" "}
                      Case studies
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/research" className="nav-link">
                      Research
                    </Link>
                    {/* <a className="nav-link" href="#">
                      Research{" "}
                    </a> */}
                  </li>
                  <li className="nav-item">
                    <Link to="/plan" className="nav-link">
                      Plans
                    </Link>
                    {/* <a className="nav-link" href="plans.html">
                      Plans
                    </a> */}
                  </li>
                  {/* <li className="nav-item">
                    <a className="nav-link" href="#">
                      Store
                    </a>
                  </li> */}
                  <li className="nav-item">
                    <a className="btn btn_manu" onClick={() => openIframeWindow()}>
                      Join EPLIMO<sup className="sup-font">TM</sup> Program
                    </a>
                  </li>
                </ul>
                {//</div>open && (
                  // <iframe
                  //   src="https://vr.biohackforlifesuccess.com/widget/form/tic4BJkP6Bm4hJUJsDKn"
                  //   style={{"width":"100%","height":"100%","border":"none","borderRadius":"3px"}}
                  //   id="inline-tic4BJkP6Bm4hJUJsDKn"
                  //   data-layout="{'id':'INLINE'}"
                  //   data-trigger-type="alwaysShow"
                  //   data-trigger-value=""
                  //   data-activation-type="alwaysActivated"
                  //   data-activation-value=""
                  //   data-deactivation-type="neverDeactivate"
                  //   data-deactivation-value=""
                  //   data-form-name="EPLIMO FUNNEL - Calendar Sign Up"
                  //   data-height="1860"
                  //   data-layout-iframe-id="inline-tic4BJkP6Bm4hJUJsDKn"
                  //   data-form-id="tic4BJkP6Bm4hJUJsDKn"
                  //   title="EPLIMO FUNNEL - Calendar Sign Up"
                  // >
                  // </iframe>
                  //    )
                }
              </div>
              <FormModal show={show} setShow={setShow} />
              {/* <FormModal  /> */}
              {/* <Modal show={show} onHide={openIframeWindow} size="lg" centered>
                <Modal.Header closeButton>
                  <h3 style={{color: "#000",textAlign: "center"}}>EPLIMO</h3>
                </Modal.Header>

                <Modal.Body style={{ padding: 0, height: "70vh" }}>
                   <iframe
                    src="https://vr.biohackforlifesuccess.com/widget/form/3qCXcsZeUEFO3EcQUfjG"
                    style={{"width":"100%","height":"100%","border":"none","borderRadius":"3px"}}
                    id="inline-tic4BJkP6Bm4hJUJsDKn"
                    data-layout="{'id':'INLINE'}"
                    data-trigger-type="alwaysShow"
                    data-trigger-value=""
                    data-activation-type="alwaysActivated"
                    data-activation-value=""
                    data-deactivation-type="neverDeactivate"
                    data-deactivation-value=""
                    data-form-name="EPLIMO FUNNEL - Calendar Sign Up"
                    data-height="1860"
                    data-layout-iframe-id="inline-tic4BJkP6Bm4hJUJsDKn"
                    data-form-id="tic4BJkP6Bm4hJUJsDKn"
                    title="EPLIMO FUNNEL - Calendar Sign Up"
                  >
                  </iframe>
                </Modal.Body>
              </Modal> */}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
